<line-chart [resource]="kpis" [metadata]="kpiMetadata()" [(dateRange)]="dateRangeOfInterest">
  <div chart-title class="chart__title-row">
    <h3 class="title-with-icon">
      <svg-icon src="assets/images/icons/chart.svg" class="black-medium"></svg-icon>
      <span>{{ "Chart.TrafficGraph" | translate }}</span>
    </h3>
  </div>
  <ng-container chart-header-left>
    <line-chart-subject-dropdown
      [subjects]="kpiSubjects()"
      [label]="'Chart.SelectKPI'"
      [(selected)]="selectedKpiSubject"
    />
  </ng-container>
</line-chart>
